import React, { useState } from "react";
import CreateQuiz from "./Create/CreateQuiz";
import BackBtn from "../../../assets/svg/backbtn.svg";
import QuizListAdmin from "../../Quiz/QuizListAdmin";

const AllQuiz = () => {
  const [showCreateQuizMenu, setShowCreateQuizMenu] = useState(false);
  const [showQuizzes, setShowQuizzes] = useState(false);

  return (
    <div className="Admin-all-quiz-page bg-transparent">

      {/* ── Heading ── */}
      {!showCreateQuizMenu && !showQuizzes && (
        <div className='ques-bank-heading' style={{ width: '100%', padding: '0 24px', boxSizing: 'border-box' }}>
          Quiz Management
        </div>
      )}

      {/* ── Landing cards ── */}
      {!showCreateQuizMenu && !showQuizzes && (
        <div className="admin-panel-cards">
          {/* Create Quiz card */}
          <div
            className="each-admin-card card-create"
            onClick={() => setShowCreateQuizMenu(true)}
          >
            <div className="card-deco" />
            <div className="card-icon-wrap">✏️</div>
            <p className="card-label">Create New Quiz</p>
            <p className="card-desc">Set up a new quiz with custom topic, questions &amp; duration</p>
            <span className="card-arrow">→</span>
          </div>

          {/* View Quizzes card */}
          <div
            className="each-admin-card card-view"
            onClick={() => setShowQuizzes(true)}
          >
            <div className="card-deco" />
            <div className="card-icon-wrap">📋</div>
            <p className="card-label">View All Quizzes</p>
            <p className="card-desc">Browse, monitor and manage all existing quizzes</p>
            <span className="card-arrow">→</span>
          </div>
        </div>
      )}

      {/* ── Create Quiz panel ── */}
      {showCreateQuizMenu && (
        <div className="create-quiz-panel">
          <div className="create-quiz-menu-bar mb-3">
            <div className="go-back" onClick={() => setShowCreateQuizMenu(false)}>
              <img src={BackBtn} alt="Back" />
            </div>
            <h2 className="create-quiz-heading">Create a New Quiz</h2>
          </div>
          <CreateQuiz />
        </div>
      )}

      {/* ── View Quizzes panel ── */}
      {showQuizzes && (
        <div className="create-quiz-panel max-w-none">
          <div className="create-quiz-menu-bar">
            <div className="go-back" onClick={() => setShowQuizzes(false)}>
              <img src={BackBtn} alt="Back" />
            </div>
            <h2 className="create-quiz-heading">All Quizzes</h2>
          </div>
          <div className="quiz-list-admin">
            <QuizListAdmin />
          </div>
        </div>
      )}

    </div>

  );
};

export default AllQuiz;
